/* AMAVYA - couche de signature. Aucune bibliotheque, aucun appel reseau. */
(function () {
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pointeurFin = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Quand les transitions de page sont actives, Horizon deplace le defilement
     de la fenetre vers .page-wrapper. On lit donc le defileur reel, sans le
     supposer. */
  function defileur() {
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight > w.clientHeight + 1) return w;
    return null;
  }

  /* 1. Arrivee des sections au defilement.
        La classe qui masque est posee ici, par le script : si le JavaScript ne
        s'execute pas, la page reste entierement visible. */
  var observateur = null;

  if (!reduit && 'IntersectionObserver' in window) {
    observateur = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting) {
          entrees[i].target.classList.add('is-in');
          observateur.unobserve(entrees[i].target);
        }
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  }

  function marquer() {
    if (!observateur) return;

    var cibles = document.querySelectorAll('#MainContent .shopify-section > *');
    for (var i = 0; i < cibles.length; i++) {
      var el = cibles[i];
      if (el.getAttribute('data-amavya-reveal')) continue;
      el.setAttribute('data-amavya-reveal', '1');
      el.classList.add('amavya-reveal');
      observateur.observe(el);
    }

    /* Filet de securite : si l'observateur ne se declenche pas, ce qui est
       deja dans l'ecran redevient visible au bout de deux secondes. */
    window.setTimeout(function () {
      var restants = document.querySelectorAll('.amavya-reveal:not(.is-in)');
      for (var j = 0; j < restants.length; j++) {
        if (restants[j].getBoundingClientRect().top < window.innerHeight) {
          restants[j].classList.add('is-in');
        }
      }
    }, 2000);
  }

  /* 2. La lumiere du bijoutier : le halo suit le pointeur sur l'objet. */
  if (pointeurFin) {
    document.addEventListener('pointermove', function (e) {
      var cible = e.target;
      if (!cible || !cible.closest) return;

      var vitrine = cible.closest('.card-gallery');
      if (!vitrine) return;

      var b = vitrine.getBoundingClientRect();
      if (!b.width || !b.height) return;

      vitrine.style.setProperty('--amavya-x', (((e.clientX - b.left) / b.width) * 100).toFixed(1) + '%');
      vitrine.style.setProperty('--amavya-y', (((e.clientY - b.top) / b.height) * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* 3. Le fil de progression de lecture.
        L'ecoute est posee sur le document en phase de capture : les evenements
        de defilement ne remontent pas, mais ils sont bien captes ainsi, quel
        que soit l'element qui defile. */
  if (!reduit && document.body) {
    var fil = document.createElement('div');
    fil.className = 'amavya-progression';
    fil.setAttribute('aria-hidden', 'true');
    document.body.appendChild(fil);

    var enAttente = false;

    var majFil = function () {
      enAttente = false;
      var d = defileur();
      var haut = d ? d.scrollTop : window.scrollY;
      var course = d
        ? d.scrollHeight - d.clientHeight
        : document.documentElement.scrollHeight - window.innerHeight;
      var part = course > 0 ? (haut / course) * 100 : 0;
      fil.style.width = Math.min(100, Math.max(0, part)) + '%';
    };

    document.addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(majFil);
    }, { capture: true, passive: true });

    majFil();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', marquer);
  } else {
    marquer();
  }

  document.addEventListener('shopify:section:load', marquer);
  window.addEventListener('pageshow', marquer);
})();
